import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { GMAIL_INTEGRATION_CREATE_PERMISSION } from "../permissions";

const IntegrationsAccessControl = ({
    children,
    baseResources = GMAIL_INTEGRATION_CREATE_PERMISSION,
}) => (
    <ComponentAccessControl baseResources={baseResources}>
        {children}
    </ComponentAccessControl>
);

export default IntegrationsAccessControl;
